import {
  Group,
  Mesh,
  Vector3,
} from 'three';

import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';

const segments = 24;
const hashLength = 20;
const linewidth = 0.001;
const zAxis = new Vector3(0, 0, 1);

// draw all of the hash marks around the ring
const hashMarkMaterial = new LineMaterial({
  color: 0x000000,
  linewidth,
});

function getHashMark(index: number, radius: number): Mesh {
  const innerRadius = radius - (hashLength / 2);
  const outerRadius = radius + (hashLength / 2);
  const theta = 2 * Math.PI * index / segments;

  const point1 = new Vector3(0, innerRadius, 0);
  const point2 = new Vector3(0, outerRadius, 0);

  point1.applyAxisAngle(zAxis, theta);
  point2.applyAxisAngle(zAxis, theta);

  const positions = [
    point1.x,
    point1.y,
    point1.z,
    point2.x,
    point2.y,
    point2.z,
  ];

  const hashMarkGeometry = new LineGeometry().setPositions(positions);

  const line = new Line2(hashMarkGeometry, hashMarkMaterial);
  line.computeLineDistances();
  line.scale.set(1,1,1);
  return line;
}

export default function makeHashMarks(radius: number): Group {
  const circleGroup = new Group();

  for (let i = 0; i < segments; i++) {
    const hashMark  = getHashMark(i, radius);
    circleGroup.add(hashMark);
  }

  return circleGroup;
}
